import { Injectable } from '@angular/core';
import { OutlookAccount } from '@models/outlookAccount';
import { Selector, State, Action, StateContext } from '@ngxs/store';
import { OutlookAccountsRepo } from '@repos/outlook-accounts/outlook-accounts.repo';
import * as actions from './actions';

export interface EmailIntegrationStateModel {
	account: OutlookAccount | null;
	loading: boolean;
}

const DEFAULT_STATE: EmailIntegrationStateModel = {
	account: null,
	loading: false,
};

@State<EmailIntegrationStateModel>({
	name: 'emailIntegration',
	defaults: DEFAULT_STATE,
})
@Injectable()
export class EmailIntegrationState {
	constructor(private outlookAccountsRepo: OutlookAccountsRepo) {}

	@Action(actions.LoadOutlookAccount)
	async loadOutlookAccount(
		ctx: StateContext<EmailIntegrationStateModel>,
		action: actions.LoadOutlookAccount,
	) {
		ctx.patchState({ loading: true });

		try {
			const account = await this.outlookAccountsRepo
				.Get(action.payload.userId)
				.toPromise();
			ctx.patchState({
				account: (account?.data() as OutlookAccount) || null,
				loading: false,
			});
		} catch {
			ctx.patchState({ account: null, loading: false });
		}
	}

	@Selector()
	static getAccount(state: EmailIntegrationStateModel): OutlookAccount | null {
		return state.account;
	}

	@Selector()
	static isLoading(state: EmailIntegrationStateModel): boolean {
		return state.loading;
	}
}
